import styled, { css } from 'styled-components';

export const AlignInAreaContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  height: 89vh;
`

export const AlignInArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px;
  margin: 5px;
  background: rgba(199,229,241,0.1);;
  border-radius: 15px;

  & > span {
    padding: 10px 0px;
  }

  & > div.iconBox {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
`;